import { HeartPulse, Sparkles, Scissors, SprayCan, Waves, ShieldCheck } from 'lucide-react';

// Doctors, Hospitals & Pharmacies are intentionally excluded from discovery for this phase.
export const discoveryCategories = [
  {
    id: 'healthcare',
    shortKey: 'hero.healthcare',
    shortFallback: 'Healthcare',
    labelKey: 'siteNav.healthcare',
    fallback: 'Healthcare Clinics',
    to: '/healthcare-providers?category=Healthcare%20Clinic',
    icon: HeartPulse,
    accent: 'text-blue-600 dark:text-blue-400',
    chip: 'bg-blue-50 dark:bg-blue-500/10',
    priority: 1,
  },
  {
    id: 'beauty',
    shortKey: 'nav.beauty',
    shortFallback: 'Beauty',
    labelKey: 'siteNav.beauty',
    fallback: 'Beauty Clinics',
    to: '/healthcare-providers?category=Beauty%20Clinic',
    icon: Sparkles,
    accent: 'text-pink-600 dark:text-pink-400',
    chip: 'bg-pink-50 dark:bg-pink-500/10',
    priority: 1,
  },
  {
    id: 'salons',
    shortKey: 'nav.salons',
    shortFallback: 'Salons',
    labelKey: 'siteNav.salons',
    fallback: 'Ladies Salons',
    to: '/healthcare-providers?category=Salon',
    icon: Scissors,
    accent: 'text-emerald-600 dark:text-emerald-400',
    chip: 'bg-emerald-50 dark:bg-emerald-500/10',
    priority: 1,
  },
  {
    id: 'barbershops',
    shortKey: 'nav.barbershops',
    shortFallback: 'Barbershops',
    labelKey: 'siteNav.barbershops',
    fallback: 'Barbershops',
    to: '/healthcare-providers?category=Barbershop',
    icon: SprayCan,
    accent: 'text-amber-700 dark:text-amber-400',
    chip: 'bg-amber-50 dark:bg-amber-500/10',
    priority: 1,
  },
  {
    id: 'spas',
    shortKey: 'nav.spas',
    shortFallback: 'Spas',
    labelKey: 'siteNav.spas',
    fallback: 'Spas',
    to: '/healthcare-providers?category=Spa',
    icon: Waves,
    accent: 'text-teal-600 dark:text-teal-400',
    chip: 'bg-teal-50 dark:bg-teal-500/10',
    priority: 1,
  },
  {
    id: 'dental',
    shortKey: 'nav.dental',
    shortFallback: 'Dental',
    labelKey: 'siteNav.dental',
    fallback: 'Dental Clinics',
    to: '/healthcare-providers?category=Dental%20Clinic',
    icon: ShieldCheck,
    accent: 'text-violet-600 dark:text-violet-400',
    chip: 'bg-violet-50 dark:bg-violet-500/10',
    priority: 2,
  },
];
